module.exports = __webpack_public_path__ + "static/media/cojoint.e956eef9.jpeg";